/*
 * @Author: 向南星 xiangnanxing@scmagic.cn
 * @Date: 2022-09-19 13:56:15
 * @LastEditors: 向南星 xiangnanxing@scmagic.cn
 * @LastEditTime: 2022-11-04 11:19:08
 */
import classNames from 'classnames';
import React from 'react';
import styles from './index.module.scss';

interface Props {
  logo: string;
  title: string;
  desc: string;
  className?: string | false;
  buttons: (JSX.Element | false | undefined)[];
  count?: number;
  labels?: (JSX.Element | false | undefined)[];
  itemsInsideLogo?: (JSX.Element | false | undefined)[];
  placeholder?: string;
}
const BaseListItem: React.FC<Props> = ({
  logo,
  title,
  desc,
  className,
  buttons,
  count,
  labels,
  itemsInsideLogo,
  placeholder
}) => {
  const filteredButtons = buttons.filter(Boolean);
  return (
    <div className={classNames(styles.container, className)}>
      <div className={styles.logo} style={{ backgroundImage: `url(${logo})` }}>
        {count && count > 0 ? (
          <div className={styles.count}>{count}</div>
        ) : null}
        {itemsInsideLogo &&
          React.Children.map(itemsInsideLogo.filter(Boolean), v => v)}
      </div>
      <div className={styles.content}>
        <div className={styles.name}>
          <span>{title}</span>
          {labels && React.Children.map(labels.filter(Boolean), v => v)}
        </div>
        <div className={styles.desc}>{desc}</div>
        <div className={styles.buttons}>
          {filteredButtons.length > 0 ? (
            React.Children.map(filteredButtons, v => v)
          ) : (
            <span className={styles.placeholder}>{placeholder}</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default BaseListItem;
